import {Box, css, List, ListItem, styled} from '@mui/material';

type StyledFooterContainerProps = {
	$mb?: number;
	$isTablet?: boolean;
};

export const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: ${props => (props.$mb ? `auto 0px ${props.$mb}px` : 'auto 0px 32px')};
	padding-top: 40px;

	${({$isTablet}) =>
		$isTablet &&
		css`
			margin: auto 0px 0px;
			& footer {
				margin-inline: 24px;
			}
		`}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export const StyledBox = styled(Box)`
	display: flex;
	flex-direction: column;
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 16px;
	border-radius: 8px;
`;

export const StyledList = styled(List)`
	list-style: disc;
	padding: 8px 24px;
`;

export const StyledListItem = styled(ListItem)`
	display: list-item;
	list-style-type: inherit;
	color: ${({theme}) => theme.palette.text.primary};
	padding: 2px 0;
`;
